import { request } from '../utils/request'
import { apiURL } from '../utils/url'
import { apiRoutes } from '../routes'
import { NextPageContext } from 'next'

export interface ServiceConfig {
  readonly fee: number
}

export async function fetchReserveFee(req?: NextPageContext['req']): Promise<ServiceConfig['fee'] | null> {
  const reqURL = apiURL(apiRoutes.reserveFee)

  const response = await request(reqURL, {}, req)
  if (!response.ok) {
    return null
  }

  const json = await response.json()
  return json.fee
}

export async function updateReserveFee(fee: number) {
  const response = await request(apiURL(apiRoutes.reserveFee), {
    method: 'POST',
    body: JSON.stringify({
      fee: fee,
    }),
  })

  return response.ok
}
